const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => localStorage.getItem("mft_admin_token");
export const setToken = (t) => localStorage.setItem("mft_admin_token", t);
export const clearToken = () => localStorage.removeItem("mft_admin_token");

export async function api(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BACKEND_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    clearToken();
    window.location.href = "/admin/login";
    throw new Error("Session expired");
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const detail = data.detail;
    const msg = Array.isArray(detail)
      ? detail.map((e) => e.msg).join(" ")
      : detail || "Request failed";
    throw new Error(typeof msg === "string" ? msg : "Request failed");
  }
  return res.json();
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const token = getToken();
  const res = await fetch(`${BACKEND_URL}/api/admin/upload-image`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Upload failed");
  }
  return res.json();
}
